module.exports = __webpack_public_path__ + "static/media/scooter-icon.7db95eb0.png";